import { useState } from 'react'
import { useUpdateUserPasswordMutation } from '@axilon-apps/domains-identity/state'
import { useFeedbackMessage } from '@axilon-apps/libs-ui-components'
import { SecretModal, ConfirmModal } from '@axilon-apps/libs-ui-components'

interface Props {
  isOpen: boolean
  close: () => void
  userId: string
  username: string
}

const ChangePasswordModal = ({ isOpen, close, userId, username }: Props) => {
  const { toast } = useFeedbackMessage()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState(false)
  const [mutation] = useUpdateUserPasswordMutation()

  const onConfirm = async () => {
    setConfirm(true)
    const { data, error } = await mutation(userId)

    if (error) {
      toast.error({ message: `Failed to update password for: ${username}` })
    } else {
      toast.success({ message: `Successfully updated password for: ${username}` })
    }
    if (data?.newPassword) setPassword(data?.newPassword)
  }

  if (!confirm) {
    return (
      <ConfirmModal
        close={close}
        isOpen={isOpen}
        confirm={onConfirm}
        description="This action will reset the selected user's password and cannot be undone"
        confirmButton="Confirm"
      />
    )
  }

  return (
    <SecretModal
      title="New password"
      description="To close the dialog, please copy the new password and ensure it is saved securely"
      openModal={isOpen}
      secret={password}
      color="success"
      onConfirm={close}
    />
  )
}

export default ChangePasswordModal
